import { Typography } from '@mui/material';

/** Figma 11059:2165 — WIN label */
function WinLabel() {
  return (
    <Typography
      sx={{
        position: 'absolute',
        left: '1.98px',
        top: '30.69px',
        width: '19.96px',
        height: '12px',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 400,
        fontSize: 10,
        lineHeight: '12px',
        letterSpacing: 0,
        color: '#fff',
        opacity: 0.7,
        textAlign: 'right',
      }}
    >
      WIN
    </Typography>
  );
}

/** Figma 11059:2166 — win count */
function WinCount({ value }) {
  return (
    <Typography
      sx={{
        position: 'absolute',
        left: '26.93px',
        top: '46.52px',
        width: '24.95px',
        height: '20px',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: '0.5px',
        color: '#fff',
        textAlign: 'right',
      }}
    >
      {value}
    </Typography>
  );
}

export default function ContestWinStat({ wins }) {
  return (
    <>
      <WinLabel />
      <WinCount value={wins} />
    </>
  );
}
